import React from 'react';
import _ from 'underscore';

import Col from 'ui-library/bs/Col';
import {InputChangeEvent} from 'util/Types';

interface PrimerRowLongFieldProps {
  inputs: Array<{
    value: string;
    onChange: (e: InputChangeEvent) => void;
    placeholder: string | number | null;
  }>;
}

function PrimerRowLongField(props: PrimerRowLongFieldProps): JSX.Element {
  return (
    <Col sm={9}>
      <input
        {
          // TODO: refactor _.extend to be type-explicit
          ..._.extend({type: 'text'}, props.inputs[0]) // eslint-disable-line no-restricted-syntax
        }
      />
    </Col>
  );
}

export default PrimerRowLongField;
